import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
    return (
        <section id="entreprises" className="about-section">
            <div className="container">
                <h2 className="text-center" style={{ marginBottom: '3rem' }}>Nos Artisans</h2>
                <div className="about-grid">
                    <div className="about-image-col">
                        <img src="/images/image.png" alt="Cédric Millet et Coline Brossard" className="about-image" />
                    </div>
                    <div className="about-text-col">
                        <h3 className="text-gold">Cédric MILLET & Coline BROSSARD</h3>
                        <p>
                            De l'audace et de la maîtrise. C'est ce qui définit le duo formé par Cédric Millet et Coline Brossard.
                            Riches d'un parcours de quinze ans au sein des plus grandes tables étoilées – de la Belgique à l'Océanie, en passant par la Suisse – ils ont choisi la chaleur d'Albi pour écrire leur propre chapitre.
                        </p>
                        <p>
                            Leur signature ? Une technique de haute volée mise au service d'une pâtisserie vivante. Cédric et Coline bousculent les codes en désucrant pour laisser parler le fruit, l'épice, l'herbe fraîche. Une quête d'authenticité où chaque création est une promesse : celle de vous faire redécouvrir le vrai goût des choses.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
